import React, { useState } from 'react';

function Hero() {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <header className="hero">
      <div className="hero__scanlines" aria-hidden="true" />
      <div className="hero__glow" aria-hidden="true" />
      <div className="hero__inner">
        {logoFailed ? (
          <div className="hero__logo hero__logo--fallback" role="img" aria-label="Cathosis">
            CATHOSIS
          </div>
        ) : (
          <img
            className="hero__logo"
            src="./logo.png"
            alt="Cathosis"
            onError={() => setLogoFailed(true)}
          />
        )}
        <p className="hero__tagline">
          Games that feel like the ones you still think about.
          <br />
          Or replay again and again.
          <br />
          Or never finished but keep meaning to.
        </p>
      </div>
    </header>
  );
}

export default Hero;
